module.exports = __webpack_public_path__ + "static/img/p-4.6bb272f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-4.png
// module id = WyEL
// module chunks = 0